import React from 'react';
import { createPortal } from 'react-dom';
import { popNotification } from '../../data-layer/notifications/actions';
import { selectNotifications } from '../../data-layer/notifications/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import { Snackbar } from '../../ui/feedback/Snackbar';
import { Stack } from '../../ui/layout/Stack';
import { withInvariant } from '../../utils/withInvariant';

export const Notifications = withInvariant(
    () => {
        const dispatch = useDispatch();
        const notifications = useSelector((state) => selectNotifications(state));

        return createPortal(
            <Stack
                p={1}
                zIndex={10_000}
                spacing={1}
                position="fixed"
                bottom={{ xs: 7, md: 0 }}
                width={{ xs: '100%', sm: 320 }}
                count={notifications.length}
                renderItem={(index) => {
                    const notification = notifications[index];

                    return (
                        <Snackbar
                            key={notification.id}
                            message={notification.message}
                            onRemove={() => dispatch(popNotification(notification))}
                        />
                    );
                }}
            />,
            window.document.getElementById('notifications')!,
        );
    },
    () => null,
);
